<template>
  <div>
    <p>年別アーカイブ</p>
    <!-- {{ years }} -->
    <ul>
      <li><router-link to="/news">全て</router-link></li>
      <li v-for="year in years" :key="year">
        <router-link :to="'/news/year/' + year">{{ year }}年</router-link>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
export default {
  name: 'NewsArchive',
  setup() {
    const years = []
    const startYear = 2020
    const currentYear = new Date().getFullYear()

    for (let i = startYear; i <= currentYear; i++) {
      years.push(i)
    }

    years.reverse()

    return {
      years
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

div {
  @include mixins.media() {
    border: 1px solid var.$color-border-gray;
    border-radius: 5px;
  }
}
p {
  background-color: var.$color-sub-bg-g;
  font-size: 2rem;
  padding: 5px 16px;
  @include mixins.media() {
    font-size: 1.8rem;
    padding: 7px 20px;
  }
}
ul {
  margin: 0 16px;
  @include mixins.media() {
    margin: 8px 20px 9px;
  }
}
li {
  border-bottom: 1px solid var.$color-border-gray;
  &:last-child {
    @include mixins.media() {
      border-bottom: 0;
    }
  }
}
a {
  display: block;
  padding: 8px 0;
}
</style>
